import { render, staticRenderFns } from "./ResultHead.vue?vue&type=template&id=a3d41e6a&lang=html"
import script from "./ResultHead.vue?vue&type=script&lang=js"
export * from "./ResultHead.vue?vue&type=script&lang=js"
import style0 from "./ResultHead.vue?vue&type=style&index=0&id=a3d41e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports